<template>
    <div class="workflow_view_sec overflow_auto padb20">
        <div class="main-list-wrap forms_title mb-0 fees_case_info"> 
            <ul class="items-list">
                <li><span>{{checkProperty(invoiceDetails, 'petitionDetails', 'typeName')}}<small class="d-block pt-2">{{checkProperty(invoiceDetails, 'petitionDetails', 'subTypeName')}}</small></span></li>
                <li v-if="checkProperty(invoiceDetails, 'petitionDetails', 'beneficiaryInfo') && checkProperty(invoiceDetails['petitionDetails'], 'beneficiaryInfo', 'name')">Beneficiary<span>{{checkProperty(invoiceDetails['petitionDetails'], 'beneficiaryInfo', 'name')}}</span></li>
                <li v-if="checkProperty(invoiceDetails, 'petitionerDetails', 'name')">Petitioner<span>{{checkProperty(invoiceDetails, 'petitionerDetails', 'name')}}</span></li>
                <li v-if="checkProperty(invoiceDetails, 'customId')" >Invoice No<span>{{checkProperty(invoiceDetails, 'customId')}}</span></li>

                <li v-if="checkProperty(invoiceDetails, 'petitionDetails', 'caseNo')" >Case No<span class="cursor" @click="redirectToDetails">{{checkProperty(invoiceDetails, 'petitionDetails', 'caseNo')}}</span></li>
                <li v-if="checkProperty(invoiceDetails, 'caseStatusDetails', 'name')">Case Status
                    <span class="status"  v-bind:class="{ [getCaseColors(checkProperty(invoiceDetails, 'caseStatusDetails', 'id'))]: true }" >{{checkProperty(invoiceDetails, 'caseStatusDetails', 'name')}}
                    </span></li>            
                </ul> 
        </div>
        <div class="main-list-wrap forms_title mb-0 fees_actions"> 
            <div>
                <ul class="items-list" v-if="invoiceDetails && totalInvoiceAmountPaid>0 ">
                
                <!-- <li>Status<span>Raised</span></li>
                <li>Last Updated <span>{{petition.filingFeeDetails.createdOn | formatDate}}</span></li> -->
                <li>Total Amount<span>{{formatprice(totalInvoiceAmountPaid)}}</span></li>
                <li>Paid Amount<span>{{formatprice(partlyPaidAmountt)}}</span></li>
                <li>Due Amount<span>{{formatprice(totalDueAmount)}}</span></li>
                <li v-if="checkProperty(invoiceDetails, 'dueDate')">Due Date<span>{{checkProperty(invoiceDetails, 'dueDate') | formatDate}}</span></li>
                <li v-if="checkProperty(invoiceDetails, 'createdOn')">Issued Date<span>{{checkProperty(invoiceDetails, 'createdOn') | formatDate}}</span></li>


                <li v-if="checkProperty(invoiceDetails, 'createdByDetails', 'name')">Issued By<span>{{checkProperty(invoiceDetails, 'createdByDetails', 'name')}}
                        <small v-if="checkProperty(invoiceDetails, 'createdByDetails', 'roleName')"> ({{ checkProperty(invoiceDetails, 'createdByDetails', 'roleName') }})</small></span></li>
                        <li v-if="checkProperty(invoiceDetails, 'invoiceDate')">Invoice Date<span>{{checkProperty(invoiceDetails, 'invoiceDate') | formatDate}}</span></li>

                <li v-if="checkProperty(invoiceDetails,'statusDetails','name')">
                    <span :class="{'status_invite':checkProperty(invoiceDetails,'statusDetails','id')==1 ,'status_fullypaid':checkProperty(invoiceDetails,'statusDetails','id')==6, 'status_partiallypaid':checkProperty(invoiceDetails,'statusDetails','id')==5 }"
                    
                    class="ml-0 status-btn2 status_sent">{{checkProperty(invoiceDetails,'statusDetails','name')}}</span></li>
                

                </ul>
            </div>
            
            <!-- canPreParePermApplication || -->
            <!-- v-if="checkProperty(petition, 'completedActivities', 'length')>0 && (petition.completedActivities.indexOf('SUBMIT_TO_LAW_FIRM') >-1 || [9].indexOf(checkProperty(petition,'typeDetails', 'id')) >-1)" -->
            
        </div>
        <div class="actions-btn-list" > 
            <ul>
                <li v-if="[3,4,13].indexOf(getUserRoleId)>-1 && showEditList"> 
                    <span  class="items_edit" @click="showEditList = false;reloadDetails()"> Cancel</span>
                </li>
                <template v-if="!(checkProperty(invoiceDetails ,'partlyPaidLogs') && invoiceDetails.partlyPaidLogs.length>0) ">
                <li v-if="[3,4,13].indexOf(getUserRoleId)>-1 && [6].indexOf(checkProperty(invoiceDetails, 'statusDetails', 'id'))<=-1 && showEditList " >
                    <vs-button class="light-blue-btn btn_primary ml-2 payment_action"   @click="updateInvoice()">
                        Update
                    </vs-button>
                </li>
                <!-- v-if="checkFIlingFeeEditPermession" -->
                <li v-if="[3,4,13].indexOf(getUserRoleId)>-1 && !showEditList " > 
                    <span  class="items_edit" @click="updateFilingFee(true) ">
                        <img src="@/assets/images/main/icon-edit.svg" />Edit
                    </span>
                </li>
              </template>
                <li v-if="[3,4,13].indexOf(getUserRoleId)>-1 && [6].indexOf(checkProperty(invoiceDetails, 'statusDetails', 'id'))<=-1 && !showEditList" >
                <vs-button class="light-blue-btn btn_primary ml-2 payment_action"   @click="opencreatePopup()">
                    Complete Payment
                </vs-button>
                </li>

            </ul>
            </div>
        <div >
            <div class="accordian-table filingfee_tabel filingfee_tabelv2" v-if="invoiceDetails && showEditList">
              <form data-vv-scope="filingFeesform"  @submit.prevent>
                <div class="vs-table--content mb-0">
                  <div class="vs-con-tbody">
                    <vs-table :data="checkProperty(invoiceDetails, 'feeDetails')">
                      
                      <template v-if="checkProperty(invoiceDetails, 'feeDetails').length > 0" slot="thead">
                        <vs-th>Filing Fees</vs-th>
                        <vs-th> </vs-th>
                        <vs-th> </vs-th>
                      </template>
                      <template slot-scope="{ data }">
                        <vs-tr class="subhead">
                          <vs-td colspan="3">
                        <h3 class="small-header d-flex justify-content-between">USCIS Fees<a @click="addMore('USCIS')" class="IB_text-link">+ Add more</a></h3> 
                        </vs-td>
                        </vs-tr>
                        <tbody>
                        <vs-tr :data="filingFee" :key="index" v-for="(filingFee ,index) in checkProperty(invoiceDetails, 'feeDetails')" class="vs-table--tr" :class="{'new-invoice-item':checkProperty(filingFee ,'newly_add')}" v-if="filingFee.type=='USCIS'  && checkProperty(filingFee, 'isSelected')">
                          <!-- <vs-td><span>{{ filingFee.name  }}</span></vs-td> -->
                          <vs-td v-if="checkProperty(filingFee, 'name') && checkProperty(filingFee, 'isAlreadyExisted')">{{ filingFee.name  }}
                            <span v-if="checkProperty(filingFee, 'online')" class="online_label">Online</span>
                          </vs-td>
                              <vs-td v-else >
                                <vs-input data-vv-as="FeeType" v-validate="'required'" :name="'feeType'+index" v-model="invoiceDetails['feeDetails'][index]['name']" class="amount_input"/>
                                <span class="text-danger text-sm" v-show="errors.has('filingFeesform.feeType'+index)">{{ errors.first('filingFeesform.feeType'+index) }}</span>
                              </vs-td>
                          <vs-td>
                            
                            <div class="amount_edit mb-0" >
                                  <vs-input
                                  data-vv-as="Amount"
                                  v-validate="'required'"
                                  :maxLength="6"
                                  v-model="filingFee.amount"
                                  oninput="this.value = this.value.replace(/[^0-9 .]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');"
                                  :name="'amountUSCIS'+index"
                                  v-mask="'######'"
                                  class="amount_input input_prefix"
                                />
                                <span
                                  class="text-danger text-sm"
                                  v-show="errors.has('filingFeesform.amountUSCIS'+index)"
                                  >{{ errors.first("filingFeesform.amountUSCIS"+index) }}
                                </span>
                            </div>
                          </vs-td>
                          <!-- @click="removeItem(index)" -->
                          <vs-td>
                            <svg v-if="checkProperty(invoiceDetails, 'feeDetails', 'length')>1 && getSelectedObj" class="binicon" @click="filingFee['isDeleted'] = true;filingFee['isSelected'] = false" width="12.9" height="17.688" viewBox="0 0 12.9 17.688"><defs></defs><g transform="translate(-121.874)"><path class="a" d="M176.415,245.215a.393.393,0,0,0,.393.393h9.972a.393.393,0,0,0,.393-.393V232.487H176.415v12.728ZM184,234.653h1.473v8.564H184Zm-2.946,0h1.473v8.564h-1.473Zm-2.946,0h1.473v8.564h-1.473Z" transform="translate(-53.47 -227.921)"/><path class="a" d="M131.635,1.805V.393A.393.393,0,0,0,131.242,0h-5.837a.393.393,0,0,0-.393.393V2.3h-2.746a.393.393,0,0,0-.393.393v.993a.393.393,0,0,0,.393.393h12.114a.393.393,0,0,0,.393-.393V2.689a.393.393,0,0,0-.393-.393h-2.746V1.805Zm-1.473.41h-3.676V1.473h3.676v.742Z"/></g></svg>
                          </vs-td>
                        </vs-tr>  
                        </tbody>
                        <vs-tr class="subhead">
                          <vs-td colspan="3"> 
                          <h3  class="small-header d-flex justify-content-between">Attorney Fees<a @click="addMore('Internal')" class="IB_text-link">+ Add more</a></h3>  
                        </vs-td>
                        </vs-tr>
                        <tbody>                  
                        <vs-tr :data="filingFee" :key="index" v-for="(filingFee ,index) in checkProperty(invoiceDetails, 'feeDetails')" class="vs-table--tr" :class="{'new-invoice-item':checkProperty(filingFee ,'newly_add')}" v-if="filingFee.type=='Internal'  && checkProperty(filingFee, 'isSelected')">
                          <!-- <vs-td>{{ filingFee.name  }}</vs-td> -->
                          <vs-td v-if="checkProperty(filingFee, 'name') && checkProperty(filingFee, 'isAlreadyExisted')">{{ filingFee.name  }}</vs-td>
                              <vs-td v-else >
                                <vs-input data-vv-as="FeeType" v-validate="'required'" :name="'feeType'+index" v-model="invoiceDetails['feeDetails'][index]['name']" class="amount_input"/>
                                <span class="text-danger text-sm" v-show="errors.has('filingFeesform.feeType'+index)">{{ errors.first('filingFeesform.feeType'+index) }}</span>
                              </vs-td>
                          <vs-td>
                            <div class="amount_edit mb-0" >
                                  <vs-input
                                  data-vv-as="Amount"
                                  :maxLength="6"
                                  v-validate="checkProperty(getUserData, 'tenantDetails', 'slug') == 'slg'?'':'required'"
                                  v-model="filingFee.amount"
                                  oninput="this.value = this.value.replace(/[^0-9 .]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');"
                                  :name="'amountAttorney'+index"
                                  v-mask="'######'"
                                  class="amount_input input_prefix"
                                />
                                <span
                                  class="text-danger text-sm"
                                  v-show="errors.has('filingFeesform.amountAttorney' + index)"
                                  >{{ errors.first("filingFeesform.amountAttorney" + index) }}
                                </span>
                            </div>
                          </vs-td>
                          <vs-td >
                            <svg v-if="checkProperty(invoiceDetails, 'feeDetails', 'length')>1 && getSelectedObj" class="binicon" @click="filingFee['isDeleted'] = true;filingFee['isSelected'] = false" width="12.9" height="17.688" viewBox="0 0 12.9 17.688"><defs></defs><g transform="translate(-121.874)"><path class="a" d="M176.415,245.215a.393.393,0,0,0,.393.393h9.972a.393.393,0,0,0,.393-.393V232.487H176.415v12.728ZM184,234.653h1.473v8.564H184Zm-2.946,0h1.473v8.564h-1.473Zm-2.946,0h1.473v8.564h-1.473Z" transform="translate(-53.47 -227.921)"/><path class="a" d="M131.635,1.805V.393A.393.393,0,0,0,131.242,0h-5.837a.393.393,0,0,0-.393.393V2.3h-2.746a.393.393,0,0,0-.393.393v.993a.393.393,0,0,0,.393.393h12.114a.393.393,0,0,0,.393-.393V2.689a.393.393,0,0,0-.393-.393h-2.746V1.805Zm-1.473.41h-3.676V1.473h3.676v.742Z"/></g></svg>
                          </vs-td>
                        </vs-tr>
                        </tbody>
                        <vs-tr class="subhead">
                          <vs-td colspan="3"> 
                            <h3 class="small-header d-flex justify-content-between">Other Fees<a @click="addMore('other')" class="IB_text-link">+ Add more</a></h3> 
                          </vs-td>
                        </vs-tr>
                        <tbody>
                        <vs-tr :data="filingFee" :key="index" v-for="(filingFee ,index) in checkProperty(invoiceDetails, 'feeDetails')" class="vs-table--tr" :class="{'new-invoice-item':checkProperty(filingFee ,'newly_add')}" v-if="['Other','other'].indexOf(filingFee.type)>-1 && checkProperty(filingFee, 'isSelected')">
                          <!-- <vs-td><span>{{ filingFee.name  }}</span></vs-td> -->
                          <vs-td v-if="checkProperty(filingFee, 'name') && checkProperty(filingFee, 'isAlreadyExisted')">{{ filingFee.name  }}</vs-td>
                              <vs-td v-else >
                                <vs-input data-vv-as="FeeType" v-validate="'required'" :name="'feeType'+index" v-model="invoiceDetails['feeDetails'][index]['name']" class="amount_input"/>
                                <span class="text-danger text-sm" v-show="errors.has('filingFeesform.feeType'+index)">{{ errors.first('filingFeesform.feeType'+index) }}</span>
                              </vs-td>
                          <vs-td>
                            
                            <div class="amount_edit mb-0" >
                                  <vs-input
                                  data-vv-as="Amount"
                                  :maxLength="6"
                                  v-validate="'required'"
                                  v-model="filingFee.amount"
                                  oninput="this.value = this.value.replace(/[^0-9 .]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');"
                                  :name="'amountUSCIS'+index"
                                  v-mask="'######'"
                                  class="amount_input input_prefix"
                                />
                                <span
                                  class="text-danger text-sm"
                                  v-show="errors.has('filingFeesform.amountUSCIS'+index)"
                                  >{{ errors.first("filingFeesform.amountUSCIS"+index) }}
                                </span>
                            </div>
                          </vs-td>
                            <vs-td>
                            <svg v-if="checkProperty(invoiceDetails, 'feeDetails', 'length')>1 && getSelectedObj" class="binicon" @click="filingFee['isDeleted'] = true;filingFee['isSelected'] = false" width="12.9" height="17.688" viewBox="0 0 12.9 17.688"><defs></defs><g transform="translate(-121.874)"><path class="a" d="M176.415,245.215a.393.393,0,0,0,.393.393h9.972a.393.393,0,0,0,.393-.393V232.487H176.415v12.728ZM184,234.653h1.473v8.564H184Zm-2.946,0h1.473v8.564h-1.473Zm-2.946,0h1.473v8.564h-1.473Z" transform="translate(-53.47 -227.921)"/><path class="a" d="M131.635,1.805V.393A.393.393,0,0,0,131.242,0h-5.837a.393.393,0,0,0-.393.393V2.3h-2.746a.393.393,0,0,0-.393.393v.993a.393.393,0,0,0,.393.393h12.114a.393.393,0,0,0,.393-.393V2.689a.393.393,0,0,0-.393-.393h-2.746V1.805Zm-1.473.41h-3.676V1.473h3.676v.742Z"/></g></svg>
                          
                          </vs-td>
                        </vs-tr> 
                        </tbody>
                      </template>
                      </vs-table>
                  </div>
                </div>
                <div class="vx-col w-full mart20" > 
                  <div class="form_group file_group">
                    <div class="vs-component marb10">
                      <label class="form_label">Cheques<em>*</em></label>
                      <div class="relative">
                        <!-- @input="upload(value)" -->
                        <file-upload v-model="fillingFeecheques" class="file-upload-input upload_file justify-center mb-0"
                          :accept="allDocEntity"
                          :name="'Documents'" :multiple="false" :hideSelected="true" @updateData="updateData"
                        >
                          <img class="file-icon" src="@/assets/images/main/file-upload.svg" />
                          Upload
                        </file-upload>
                        <!-- <span v-if="uploading" class="loader"><img src="@/assets/images/main/loader.gif" /></span> -->
                        
                        <input type="hidden" :name="'Documents'" v-validate="'required'"  data-vv-as="Cheques"  v-model="fillingFeecheques">
                        <span class="text-danger text-sm" v-show="errors.has('filingFeesform.Documents')">{{ errors.first('filingFeesform.Documents') }}</span>

                        <!-- <span class="text-danger text-sm" v-if="DocErr">*Documents are required</span> -->
                      </div>
                    </div>
                    <ul class="uploaded-list note_uploads mt-1">
                      <template v-for="(item, index) in invoiceDetails['filingFeeDocs']['cheques']">
                        <vs-chip @click="remove(index)" :key="index" closable>
                          {{ item.name }}
                        </vs-chip>
                      
                      </template>
                    </ul>
                  </div>
                </div>
              </form>
            </div>
            
            
            <div class="accordian-table filingfee_tabel filingfee_tabelv2" v-if="invoiceDetails && !showEditList">
            <template v-if="checkProperty(invoiceDetails,'feeDetails') && (invoiceDetails.feeDetails.length>0)">
            <template v-if="checkProperty(invoiceDetails,'feeDetails') && (invoiceDetails.feeDetails.length>0)">
                <vs-table :data="invoiceDetails.feeDetails" class="fees_table "> 
                  
                    <template slot="thead">
                    <vs-th  class="padl15">
                        Filing Fee   
                    </vs-th>
                    <vs-th>
                         
                    </vs-th>
                    <!-- <vs-th >
                        Exclude from Invoice
                    </vs-th>  -->
                    </template>

                    <template slot-scope="{data}">
                      <vs-tr class="subhead" v-if="getUscisSection" >
                        <vs-td colspan="2" class="padl15">
                    <h3 class="small-header pt-0 pb-0 mb-0">USCIS Fees</h3>
                    </vs-td>
                    </vs-tr>
                    <tbody v-if="getUscisSection">
                      <vs-tr v-for="filingfee in data" :key="filingfee" v-if="filingfee.type=='USCIS'&& checkProperty(filingfee, 'isSelected') ">
                          
                          <vs-td > {{ filingfee.name }}
                            <span v-if="checkProperty(filingfee, 'online')" class="online_label">Online</span>
                          </vs-td>

                          <vs-td>
                          {{formatprice(filingfee.amount)}}
                          </vs-td>

                          <!-- <vs-td> v-html="filingfee.name"
                          <template v-if="filingfee.invoice">
                              <img   src="@/assets/images/main/checkmark.svg">
                          </template>
                          <template v-else>N/A</template>
                          

                          </vs-td> -->
                      </vs-tr>
                    </tbody>
                    <vs-tr class="subhead" v-if="getInternalSection" >
                      <vs-td colspan="2" class="padl15">
                        <h3 class="small-header pt-0 pb-0 mb-0">Attorney Fees</h3>
                      </vs-td>
                      </vs-tr>
                    <tbody v-if="getInternalSection">
                      <vs-tr v-for="filingfee in data" :key="filingfee" v-if="filingfee.type=='Internal'&& checkProperty(filingfee, 'isSelected')"> 
                          <vs-td v-html="filingfee.name">  
                          </vs-td>
                          <vs-td>
                          {{formatprice(filingfee.amount)}}
                          </vs-td>
                          <!-- <vs-td>
                          <template v-if="filingfee.invoice">
                              <img   src="@/assets/images/main/checkmark.svg">
                          </template>
                          <template v-else>N/A</template>
                          </vs-td> -->
                      </vs-tr>
                    </tbody>
                    <vs-tr class="subhead" v-if="getotherSection" >
                      <vs-td colspan="2" class="padl15">
                        <h3 class="small-header pt-0 pb-0 mb-0">Other Fees</h3>
                    </vs-td>
                    </vs-tr>
                    <tbody v-if="getotherSection" >
                      <vs-tr v-for="filingfee in data" :key="filingfee" v-if="['Other','other'].indexOf(filingfee.type)>-1 && checkProperty(filingfee, 'isSelected')" >
                          
                          <vs-td v-html="filingfee.name">
                          
                          </vs-td>

                          <vs-td>
                          {{formatprice(filingfee.amount)}}
                          </vs-td>

                          <!-- <vs-td>
                          <template v-if="filingfee.invoice">
                              <img   src="@/assets/images/main/checkmark.svg">
                          </template>
                          <template v-else>N/A</template>
                          

                          </vs-td> -->
                      </vs-tr>
                    </tbody>
                    </template>
                </vs-table>
                </template>
                <template v-if="false">
                <vs-table :data="invoiceDetails.feeDetails" class="fees_table pt-5"> 
                    <template slot="thead">
                    <vs-th>
                        Fee Type   
                    </vs-th>
                    <vs-th>
                        Amount
                    </vs-th>
                    <vs-th >
                        Exclude from Invoice
                    </vs-th> 
                    </template>

                    <template slot-scope="{data}">
                        <vs-tr v-for="filingfee in data" :key="filingfee" >
                        <vs-td v-html="filingfee.name">
                            
                        </vs-td>

                        <vs-td>
                            {{formatprice(filingfee.amount)}}
                        </vs-td>

                        <vs-td>
                            <template v-if="filingfee.invoice">
                                <img   src="@/assets/images/main/checkmark.svg">
                        </template>
                        <template v-else>N/A</template>
                            

                        </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
                </template>
            </template>
                <template v-if="!(checkProperty(invoiceDetails,'feeDetails') && (invoiceDetails.feeDetails.length>0))"> 
                    <NoDataFound ref="NoDataFoundRef" :loading="false" content="" heading="No Fees/Invoices Found" type='Fees/Invoices' />
                </template>
            
            
            </div>

            

        </div>
        
    <template v-if="(checkProperty(invoiceDetails,'filingFeeDocs') && checkProperty(invoiceDetails ,'filingFeeDocs', 'cheques') && checkProperty(invoiceDetails['filingFeeDocs'],'cheques','length')>0  && !showEditList)">
        <div class="px-6 mart30">
        <documentsView @download_or_view="download_or_view" :type="'Cheques'" :label="'Cheques'"  :documentsList="invoiceDetails['filingFeeDocs']['cheques']" :petitionDetails="invoiceDetails" />
        </div>
    </template>
    <template v-if="checkProperty(invoiceDetails ,'partlyPaidLogs') && (invoiceDetails.partlyPaidLogs.length>0)  && !showEditList" >
      <div class="accordian-table filingdata_table filingdata_table_v2">
         <paymentList :petition="updatedFillingDetails" />
      </div>
     </template>
     <addPayment
     @reloadDetails="reloadDetails"
     :callFromList="true"
     :callFromCaseDetails="true"
    :petitionDetails="updatedFillingDetails"
    :ACTIVITYCODE="ACTIVITYCODE"
    @hideMe="addPaymentPopup = false"
    v-if="addPaymentPopup"
    />
    <template>
        <invoicePopup
        @hideInvoiceMe="hideInvoice"
        @reloadDetails="reloadDetails"
        :callFromList="true"
        :petitionDetails="updatedFillingDetails"
        :ACTIVITYCODE="ACTIVITYCODE"
        @hideMe="showEditPopup = false"
        v-if="showEditPopup"
        />
    </template>
    <!-- <invoiceEditPopup
        @hideInvoiceMe="hideInvoiceEdit"
        @reloadDetails="reloadDetails"
        :callFromList="true"
        :petitionDetails="updatedFillingDetails"
        :ACTIVITYCODE="ACTIVITYCODE"
        @hideMe="showEditList = false"
        v-if="showEditList"
        /> -->
    
    </div>
</template>
<script>

//import invoiceEditPopup from "@/views/invoice/invoiceEditPopup.vue"; 
import paymentList from "@/views/petition/paymentList.vue"
import documentsView from "@/views/common/documentsView.vue";
import invoicePopup from "@/views/invoice/invoicePopup.vue"; 
import addPayment from "@/views/actionpopups/perm/addPayment.vue"; 
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import moment from "moment";
import FileUpload from "@/views/FileUpload.vue";
const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2
});
export default {
    props: {
        invoiceData:null,
        callFromCaseDetails:{
            type: Boolean,
            default: false
        }
    },
    components: {
      FileUpload,
        //invoiceEditPopup,
        VuePerfectScrollbar,
        addPayment,
        documentsView,
        invoicePopup,
        paymentList
    },
    data: () => ({
        fillingFeecheques:[],
        settings: {},
        invoiceDetails:null,
        showEditPopup:false,
        updatedFillingDetails:{
            filingFeeDetails:{},
            typeDetails:{
                name:'',
                id:null
            },
            subTypeDetails:{
                name:'',
                id:null
            },
            invoiceId:'',
            _id:'',
            filingFeeCategoryType:'',
        },
        addPaymentPopup:false,
        ACTIVITYCODE:null,
        isCompleted:false,
        partlyPaidAmountt:0,
        totalInvoiceAmountPaid:0,
        totalDueAmount:0,
        showEditList:false,
    }),
    methods:{
      removeItem(index){
      this.invoiceDetails['feeDetails'].splice(index,1)
    },
      remove(index){
        let item=this.invoiceDetails['filingFeeDocs']['cheques'][index]
        this.invoiceDetails['filingFeeDocs']['cheques'].splice(index ,1)
        this.removeFileFromS3(item)
      },
      updateData(docs){
        this.invoiceDetails['filingFeeDocs']['cheques'] = docs;
      },
      addMore(type="other"){
        let objIds = _.map(this.invoiceDetails['feeDetails'], 'id')
        let maxId = objIds.length > 0 ? _.max(objIds) : 0;
        let time = new Date().getTime();
        let otherFeeObj={
          'invoice':false,
          'amount':0,
          'name':"",
          'type':type,
          'id': time,
          isSelected:true,
          isAlreadyExisted:false,
          isDeleted:false,
        }
        this.invoiceDetails['feeDetails'].push(otherFeeObj)
      },
        hideInvoiceEdit(){
            this.showEditList=false;
            this.reloadDetails()
        },
        scroll(){},
        updateInvoice(){ //
          this.$validator.validateAll('filingFeesform').then(result => {
          if(result){
              let self = this;
              var totala = 0;
              this.checkProperty( this.invoiceDetails ,'feeDetails').forEach((i) => {
                if(i['isSelected'] && i.amount){
                  totala = totala + parseInt(i.amount);
                }
                
              });
              var postdata = {
              companyName: '',
              beneficiaryName: this.checkProperty( this.invoiceDetails['petitionDetails'] , 'beneficiaryInfo','name'), 
              beneficiaryCustomId: '',
              petitionType: this.checkProperty( this.invoiceDetails , 'petitionType'), 
              companyId: self.checkProperty(this.invoiceDetails, "companyId"),
              petitionId: this.checkProperty( this.invoiceDetails ,'petitionId'),
              feeDetails: this.checkProperty( this.invoiceDetails ,'feeDetails'),
              invoiceId : this.checkProperty( this.invoiceDetails ,'_id'),
              statusId : 2,
              statusName : "Sent",
              filingFeeDocs:{"cheques":[]},
              amount: totala?totala:0,
              today: moment().format("YYYY-MM-DD"),
              invoiceDate:this.invoiceDate,
              dueDate:this.dueDate,
              customer: {
                Id: self.checkProperty(this.invoiceDetails, "companyDetails", "qbCustomerId"),
                displayName: "", //this.petitionDetails.companyDetails.name,
                email: "", //this.petitionDetails.companyDetails.authorizedSignatory.email,
              },
              invoiceTerms: {
                days: 30,
              },
              // comment: this.filingFeeComment,
              emailInvoice: self.checkPaymentIntigration, //this.emailInvoice
              };
      
              if(this.checkProperty(self.invoiceDetails, 'filingFeeDocs', 'cheques')){
                postdata['filingFeeDocs']['cheques'] = this.checkProperty(self.invoiceDetails, 'filingFeeDocs', 'cheques');
              
              }
        
              if (this.checkProperty(self.invoiceDetails, "companyDetails")) {
                postdata["customer"]["Id"] = this.checkProperty(
                  self.invoiceDetails,
                  "companyDetails",
                  "qbCustomerId"
                );
                postdata["customer"]["displayName"] = this.checkProperty(
                  self.invoiceDetails,
                  "authorizedSignatory",
                  "name"
                );
                postdata["customer"]["email"] = this.checkProperty(
                  self.invoiceDetails,
                  "authorizedSignatory",
                  "email"
                );
              }
              this.$store.dispatch("updateFilingFees", postdata).then((response) => {
                this.showToster({ message: response.message, isError: false });
                this.showEditList = false;
                this.reloadDetails()
              }).catch((err)=>{

              })
            }
          })
        },
        updateList(){
            this.invoiceDetails = _.cloneDeep(this.invoiceDetails)
        },
        hideInvoice(){
          this.showEditList = false;
            //this.showEditPopup=false;
            this.reloadDetails()
        },
       
        redirectToDetails(){
          if(this.callFromCaseDetails){
            this.$emit('hideMePopup')
          }else{
            let routeId = this.checkProperty(this.invoiceDetails, 'petitionId') 
            if(this.checkProperty(this.invoiceDetails, 'petitionDetails', 'subType') == 15){
                this.$router.push({ name: 'gc-employment-details', params: { itemId: routeId, tabname: 'Fees/Invoices' } }).catch(err => { })
            }else{
                this.$router.push({ name: 'petition-details', params: { itemId: routeId, tabname: 'Fees/Invoices' } }).catch(err => { })
                // this.$router.push({ name: 'petition-details', params: { itemId: routeId } }).catch(err => { })
            }
          }
            
            // this.$store.dispatch("setPetitionTab", 'Fees/Invoices');
        },
        opencreatePopup(){
            this.ACTIVITYCODE = 'ADD_PAYMENT';
            this.addPaymentPopup =true;
        },
        checkPaidAmount(){
            this.partlyPaidAmountt = 0;
            this.totalInvoiceAmountPaid = 0;
            this.totalDueAmount = 0;
            let totalInvoiceAmount = 0
            let totalPaidAmount = 0
            if(this.checkProperty(this.invoiceDetails,'feeDetails') && this.checkProperty(this.invoiceDetails,'feeDetails','length')>0 ){
                let filingfeeList = _.cloneDeep(this.checkProperty(this.invoiceDetails, 'feeDetails'))
                filingfeeList.forEach(item => {
                if(!item.invoice && item['isSelected']){
                    totalInvoiceAmount += item.amount;
                }
                });
            }
            //alert(totalInvoiceAmount)
            if(totalInvoiceAmount != 0){
                this.totalInvoiceAmountPaid = totalInvoiceAmount
                
            }
            if(this.checkProperty(this.invoiceDetails,'partlyPaidLogs') && this.checkProperty(this.invoiceDetails,'partlyPaidLogs','length')>0 ){
                let filingfeeList = _.cloneDeep(this.checkProperty(this.invoiceDetails, 'partlyPaidLogs'))
                filingfeeList.forEach(item => {
                totalPaidAmount += item.amount;
                });
            }
            if(totalPaidAmount != 0){
                this.partlyPaidAmountt= totalPaidAmount
                //alert(this.partlyPaidAmountt)
            }
            if(this.partlyPaidAmountt == 0 && this.totalInvoiceAmountPaid ){
                this.totalDueAmount = this.totalInvoiceAmountPaid 
                //alert( this.totalDueAmount)
            }
            if(this.partlyPaidAmountt && this.totalInvoiceAmountPaid ){
                this.totalDueAmount = this.totalInvoiceAmountPaid - this.partlyPaidAmountt
            }
            this.isCompleted = true
            
        },
        formatprice(amount) {
         return formatter.format(amount);
        },
        updateFilingFee(){
          this.fillingFeecheques = this.invoiceDetails['filingFeeDocs']['cheques']
            if(this.callFromCaseDetails){
              //this.showEditPopup = true;
              this.showEditList = true;
            }else{
              this.showEditList = true;
                 //this.showEditPopup = true;
            }
            
        },
        download_or_view(item){
            this.$emit('download_or_view',item);
        },
        updateFeedetails(){
            // this.updatedFillingDetails['filingFeeDetails'] = {};  
            this.updatedFillingDetails['filingFeeDetails'] = this.invoiceDetails;
            this.updatedFillingDetails['invoiceId'] = this.checkProperty(this.invoiceDetails, '_id');
            this.updatedFillingDetails['_id'] = this.checkProperty(this.invoiceDetails, 'petitionId');
            this.updatedFillingDetails['typeDetails']['name'] = this.checkProperty(this.invoiceDetails,'petitionDetails', 'typeName');
            this.updatedFillingDetails['typeDetails']['id'] = this.checkProperty(this.invoiceDetails,'petitionDetails', 'type');
            this.updatedFillingDetails['subTypeDetails']['id'] = this.checkProperty(this.invoiceDetails,'petitionDetails', 'type');
            this.updatedFillingDetails['subTypeDetails']['name'] = this.checkProperty(this.invoiceDetails,'petitionDetails', 'subTypeName');
            this.updatedFillingDetails['filingFeeCategoryType'] = this.checkProperty(this.invoiceDetails, 'filingFeeCategoryType')

           
        },
        reloadDetails(){
            let query ={  
            "invoiceId": this.checkProperty(this.invoiceDetails, '_id')
            };    
         this.$store
          .dispatch("getList",{data:query ,path:'/invoices/details'} )
          .then(response => {
             this.invoiceDetails = response;
             this.checkPaidAmount();
             this.updateFeedetails()
             if(this.invoiceDetails && this.checkProperty(this.invoiceDetails, 'feeDetails')  && this.checkProperty(this.invoiceDetails, 'feeDetails', 'length')>0){
              _.forEach(this.invoiceDetails['feeDetails'], (item)=>{
                item['isAlreadyExisted'] = true;
                item['isDeleted'] = false;
              })
            }
            //  if(callFromReload){
            //   this.$refs['invoiveDetailsPopup'].checkPaidAmount()
            //  }
             //console.log(JSON.stringify(response))
             //this.showDetailsPopup =true;
            }).catch(error => {
             
            })
            //this.$emit('reloadDetails')
        },
    },
    mounted() {
        if(this.invoiceData){
            this.invoiceDetails = _.cloneDeep(this.invoiceData);
            if(this.invoiceDetails && this.checkProperty(this.invoiceDetails, 'feeDetails')  && this.checkProperty(this.invoiceDetails, 'feeDetails', 'length')>0){
              _.forEach(this.invoiceDetails['feeDetails'], (item)=>{
                item['isAlreadyExisted'] = true;
                item['isDeleted'] = false;
              })
            }
        }
        setTimeout(()=>{
            this.checkPaidAmount();
            this.updateFeedetails()
        },10)
        

    },
    computed: {
      getSelectedObj(){
        let returnVal = false;
          let list = [];
          if(this.checkProperty(this.invoiceDetails, 'feeDetails') && this.checkProperty(this.invoiceDetails,'feeDetails','length')>0 ){
            _.forEach(this.invoiceDetails['feeDetails'], (item)=>{
              if(item && item['isSelected'] && !item['isAlreadyExist']){
                list.push(item)
              }
            })
          }
          if(list&& list.length>1){
            returnVal = true
          }
          return returnVal

      },
          getUscisSection(){
            let returnVal = false;
            // filingFeeData type USCIS
            if(this.checkProperty(this.invoiceDetails, 'feeDetails' )&& this.checkProperty(this.invoiceDetails.feeDetails, 'length')>0){
              let findObj = _.find(this.invoiceDetails.feeDetails, {'type':'USCIS', 'isSelected':true});
              if(findObj){
                returnVal = true;
              }
            }
            return returnVal;
          },
          getotherSection(){
            let returnVal = false;
            // filingFeeData type USCIS ['Other','other'].indexOf(filingFee.type)>-1
            if(this.checkProperty(this.invoiceDetails, 'feeDetails' )&& this.checkProperty(this.invoiceDetails.feeDetails, 'length')>0){
              let findObj = _.find(this.invoiceDetails.feeDetails, {'type':'Other', 'isSelected':true});
              if(findObj){
                returnVal = true;
              }else{
                let findOther = _.find(this.invoiceDetails.feeDetails, {'type':'other', 'isSelected':true});
                if(findOther){
                  returnVal = true;
                }
              }
            }
            return returnVal;
          },
          getInternalSection(){
            let returnVal = false;
            // filingFeeData type USCIS 
            if(this.checkProperty(this.invoiceDetails, 'feeDetails' )&& this.checkProperty(this.invoiceDetails.feeDetails, 'length')>0){
              let findObj = _.find(this.invoiceDetails.feeDetails, {'type':'Internal', 'isSelected':true});
              if(findObj){
                returnVal = true;
              }
            }
            return returnVal;
          },
        }

}
</script>